import { Helmet } from "react-helmet-async";
import { useTranslation } from "react-i18next";

const DEFAULT_OG_IMAGE = "/logo-3aqarate.png";
const APP_URL = process.env.REACT_APP_BACKEND_URL || "https://maghreb-real-estate.preview.emergentagent.com";

export const SEO = ({ title, description, image, path, type = "website", listing }) => {
  const { i18n } = useTranslation();
  const lang = (i18n.language || "fr").split("-")[0];
  const ogLocale = lang === "fr" ? "fr_FR" : lang === "ar" ? "ar_MA" : "en_US";

  const fullTitle = title ? `${title} · 3aqarate` : "3aqarate · Marché immobilier du Maghreb sans frontières";
  const desc = description || "Annonces immobilières vérifiées au Maroc, Algérie et Tunisie. Particuliers et agences pro. Recherche puissante, carte interactive et contact direct.";
  const url = path ? `${APP_URL}${path}` : APP_URL;
  const ogImage = image || `${APP_URL}${DEFAULT_OG_IMAGE}`;

  const altLangs = ["fr", "ar", "en"].filter((l) => l !== lang);

  return (
    <Helmet>
      <html lang={lang} dir={lang === "ar" ? "rtl" : "ltr"} />
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />
      <link rel="canonical" href={url} />

      {/* hreflang */}
      <link rel="alternate" hrefLang={lang} href={url} />
      {altLangs.map((l) => (
        <link key={l} rel="alternate" hrefLang={l} href={`${url}${url.includes("?") ? "&" : "?"}lng=${l}`} />
      ))}
      <link rel="alternate" hrefLang="x-default" href={url} />

      {/* OpenGraph */}
      <meta property="og:type" content={type} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={desc} />
      <meta property="og:image" content={ogImage} />
      <meta property="og:url" content={url} />
      <meta property="og:locale" content={ogLocale} />
      <meta property="og:site_name" content="3aqarate" />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={desc} />
      <meta name="twitter:image" content={ogImage} />

      {/* Listing-specific structured data */}
      {listing && (
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "RealEstateListing",
            name: listing.title,
            description: listing.description,
            image: listing.photos?.[0],
            url,
            offers: {
              "@type": "Offer",
              price: listing.price,
              priceCurrency: listing.currency,
              availability: "https://schema.org/InStock",
            },
            address: {
              "@type": "PostalAddress",
              addressLocality: listing.city,
              addressRegion: listing.neighborhood,
              addressCountry: listing.country,
            },
            floorSize: {
              "@type": "QuantitativeValue",
              value: listing.surface,
              unitCode: "MTK",
            },
            numberOfRooms: listing.rooms,
          })}
        </script>
      )}
    </Helmet>
  );
};
